<template>
    <td class="border-t">
        <inertia-link v-if="href" class="px-6 py-4 flex items-center" :href="href" tabindex="-1">
            <slot></slot>
        </inertia-link>
        <div v-else class="px-6 py-4 flex items-center">
            <slot></slot>
        </div>
    </td>
</template>

<script>
export default {
    props: {
        href: String,
    }
}
</script>